import {defaultSelectedListaChequeo, filtro, defaultPlanAccion} from './state';

export function setListasChequeo(state, listaChequeo) {
    listaChequeo.data.map(l => l.seleccion = false)

    state.listasChequeoExistente = listaChequeo;
}

export function setListaChequeo(state, listaChequeo) {
    listaChequeo.planeacion = null;
    state.selectedListaChequeo = listaChequeo;

    state.selectedListaChequeo.seleccionar_ubicacion = !!listaChequeo.id_ubicacion;
}

export function setListarTipoSeguimiento(state, tipoSeguimientos) {
    state.tipoSeguimientos = tipoSeguimientos;
}

export function setListarTipoListaChequeo(state, tipoListaChequeo) {
    state.tipoListaChequeo = tipoListaChequeo;
}

export function setListaEmpresa(state, empresa) {
    state.empresas = empresa.data;
}

export function setFiltroEmpresa(state, buscar) {
    state.filtro.id_empresa = buscar;
}

export function setListaChequeoId(state, id) {
    state.selectedListaChequeo.id = id;
}

export function setAccion(state, accion) {
    state.accion = accion;
}

export function setPermisosAdmin(state, permiso) {
    state.esAdmin = permiso;
}

export function setPermisosEmpresa(state, permiso) {
    if (!state.esAdmin) {
        state.esEmpresa = permiso;
    }
}

export function accionError(state) {
    state.error = true;
}

export function setPage(state, page) {
    state.filtro.page = page;
}

export function resetSelectedListaChequeo(state) {
    Object.assign(state.selectedListaChequeo, defaultSelectedListaChequeo());
    state.listaTipoSeguimientos = [];
}

/**
 * Limpiar filtro de inspecciones
 *
 * @export
 * @param {*} state
 */
export function limpiarFiltro(state) {
    Object.assign(state.filtro, filtro());
    state.listasChequeoExistente = {data:[]};
}


export function establecerEmpresas(state, empresas) {
    state.empresas = empresas;
}

/**
 * Establecer empresas
 */
export function establecerEmpresasFiltro(state, empresas) {
    state.empresas_filtro = empresas;
}

export function establecerPlaneacionesAuditoriasHallazgos(state, planeacionesAuditoriasHallazgos) {
    state.planeacionesAuditoriasHallazgos = planeacionesAuditoriasHallazgos;
}

export function establecerHallazgosSelectedListaChequeo(state, hallazgos) {
    state.selectedListaChequeo.hallazgos = hallazgos;
}

/** Obtiene el tipo de seguimiento al editar o crear un hallazgo
 *
 * @param {*} state
 * @param {*} tipoSeguimientos
 */
export function setMostrarTipoSeguimiento(state, tipoSeguimientos) {

    tipoSeguimientos.map(i => {
        i.items = i.items_lista_chequeos.length > 0 ? i.items_lista_chequeos : i.items;
    });

    if (state.selectedListaChequeo.hallazgos) {
        tipoSeguimientos.map(i => {
            i.items.map(item => {
                state.selectedListaChequeo.hallazgos.map(plan => {
                    if (item.id === plan.id_item) {
                        item.ubicacion = plan.ubicacion;
                        item.cumple = plan.cumple;
                        item.observaciones = plan.observaciones;
                        item.opciones_mejora = plan.opciones_mejora;
                        item.id_hallazgo = plan.id;
                        item.id_empresa = state.selectedListaChequeo.id_empresa;
                        item.legislacion = plan.legislacion;
                    }
                });
            });
        });
    }

    state.listaTipoSeguimientos = tipoSeguimientos;
}

/**
 *
 * @param {*} state
 * @param {*} listaChequeo
 */
export function cargaHallazgos(state, hallazgo) {
    state.hallazgoArr = [];

    hallazgo.forEach(i => {
        i.items.forEach(e => {
            let hall = state.hallazgoArr.find(h => h.id_item === e.id && h.id_tipo_seguimiento === e.id_tipo_seguimiento);

            if (!hall) {
                state.hallazgoArr.push({
                    id: e.id_hallazgo,
                    id_empresa: e.id_empresa,
                    id_lista_chequeo: state.id_lista_chequeo,
                    id_tipo_seguimiento: e.id_tipo_seguimiento,
                    id_item: e.id,
                    ubicacion: e.ubicacion || '',
                    cumple: e.cumple || 0,
                    observaciones: e.observaciones || '',
                    opciones_mejora: e.opciones_mejora || '',
                    legislacion: e.legislacion || '',
                });
            }
        });
    });

    state.selectedListaChequeo.hallazgos = state.hallazgoArr;
}

/**
 * Mutación para limpiar las gráficas.
 *
 * @export
 * @param {*} state
 */
export function resetGraphics(state) {
    state.graficaGeneral = [];
    state.graficaTipoSeg = [];
    state.datoGrafica1   = [];
    state.datoGrafica2   = [];
}

export function setGraficas(state, graficas) {
    state.datoGrafica2 = [];
    state.graficaGeneral = Object.assign({}, graficas.data[0], graficas.data[1]);
    state.datoGrafica1 = graficas.data[0];

    state.graficaTipoSeg = graficas.data2;
    graficas.data2.forEach(el => {
        state.datoGrafica2.push([
            el.key,
            el.value
        ]);
    });
}

/**
 * Mutación para limpiar el plan de acción.
 *
 * @export
 * @param {*} state
 */
export function resetPlanAccion(state) {
    state.plan_accion = {
        data: {
            hallazgos: []
        }
    }
}

/**
 * Mutacion para cargar la informacion de plan de acción.
 *
 * @param {*} state
 * @param {*} plan_accion
 */
export function setPlanAccion(state, plan_accion) {


    state.plan_accion = {
        data: {
            hallazgos: []
        }
    };

    state.imagenPlanAccion = [];

    state.datos_accion = {
        responsable: '',
        fecha_inicio_visita: '',
        fecha_cierre_visita: ''
    };

    state.plan_accion = plan_accion;

    state.imagenPlanAccion = plan_accion.data2;

    state.datos_accion.id = plan_accion.data.id;
    state.datos_accion.responsable = plan_accion.data.responsable;
    state.datos_accion.fecha_inicio_visita = plan_accion.data.fecha_inicio_visita;
    state.datos_accion.fecha_cierre_visita = plan_accion.data.fecha_cierre_visita;

}

export function setListasPlaneacionHallazgos(state, planeacionesAuditoriasHallazgos) {
    state.planeacionesAuditoriasHallazgos = planeacionesAuditoriasHallazgos;
}

export function setListaImagenes(state, imagenes) {
    if (imagenes[0]) {
        const verificarPlaneacion = Object.keys(imagenes[0]);
        if (verificarPlaneacion.indexOf('registro') != -1) {
            for (var i = 0; i < imagenes.length; i++) {
                imagenes[i].imagen = imagenes[i].registro;
                imagenes[i].mostrar_imagen = i < 2 ? 1 : 0;
            }
        }
    }

    state.arrImage = imagenes;
}

export function establecerCargandoDatosSelect(state, cargando_datos_select) {
    state.cargando_datos_select = cargando_datos_select;
}

export function imagenUpdate(state, registro) {
    state.imagenSelecc = registro;
}

export function imagenCambiar(state, image) {
    state.imagenChange = image;
}

export function establecerIdEmpresaSelectedListaChequeo(state, id_empresa) {
    state.selectedListaChequeo.id_empresa = id_empresa;
}

export function setImagen(state, imagen_seleccionada) {
    state.imagen_seleccionada = imagen_seleccionada;
}

export function establecerIdUbicacion(state, id_ubicacion) {
    state.selectedListaChequeo.id_ubicacion = id_ubicacion;
}


export function establecerIdUbicacionFiltro(state, id_ubicacion) {
    state.filtro.id_ubicacion = id_ubicacion;
}


export function establecerUbicaciones(state, ubicaciones) {
    state.ubicaciones = ubicaciones;
}

export function establecerUbicacionesFiltro(state, ubicaciones_filtro) {
    state.ubicaciones_filtro = ubicaciones_filtro;
}

export function setTipoListaChequeo(state, tipo_lista_chequeo) {
    state.tipo_lista_chequeo = tipo_lista_chequeo
}

export function updateFilter(state, {company_id, slq_location_id}) {
    state.filtro.id_ubicacion = slq_location_id;
    state.filtro.id_empresa = company_id;
}
/*
* Establecer filtros para traer información de hallazgos.
*/
export function updateIdTipoListaChequeo(state, {list_check, company_id}) {
    state.selectedListaChequeo.id = list_check;
    state.selectedListaChequeo.id_empresa = company_id
}

/**
 * Mutar la información para las graficas: Estado De cumplimiento.
 * 
 * @param {*} state 
 * @param {*} nextState 
 * @author Fernando Claros
 */
export function setDataToChartGeneralFindings(state, nextState) {
    state.dataToChartGeneralFindings = nextState
}

/**
 * Mutar la información para las graficas: Porcentaje De Cumplimiento Por Items.
 * 
 * @param {*} state 
 * @param {*} nextState 
 * @author Fernando Claros
 */
export function setDataToChartPercentageOfComplianceByItem(state, nextState) {
    state.dataToChartPercentageOfComplianceByItem = nextState
}

/**
 * Establecer el nombre de la ubicación a la lista de chequeo.
 * 
 * @param {*} state 
 * @param {*} nextState 
 * @author Fernando Claros
 */
export function setLocationNameToCheckList(state, nextState) {
    state.selectedListaChequeo.ubicacion = nextState;
}